package com.exura.pages.planCreator.components.seriesViews.sections

import androidx.compose.runtime.Composable
import com.exura.features.plandefinition.domain.model.plan.PlanType
import com.exura.pages.planCreator.components.seriesViews.inputs.ModeOption
import com.exura.pages.planCreator.components.seriesViews.inputs.ModeSelectorInput
import com.exura.pages.planCreator.components.seriesViews.inputs.PlanCreatorInputMode
import com.exura.pages.planCreator.components.seriesViews.inputs.PlanCreatorIntegerInput
import com.exura.ui.Dimens
import com.exura.ui.TextStyles
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.minWidth
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.px

enum class RelativeDayMode {
    NONE,
    ON_VISIT_DAY,
    DAYS_OFFSET;
}

fun relativeDayModeOption(
    mode: RelativeDayMode,
    planType: PlanType,
    daysOffset: Int,
    inputMode: PlanCreatorInputMode,
    onDaysOffsetChange: (Int) -> Unit,
    onModeChange: (RelativeDayMode) -> Unit = {},
): ModeOption<RelativeDayMode> = when (mode) {
    RelativeDayMode.ON_VISIT_DAY -> ModeOption(
        onClick = {
            onModeChange(RelativeDayMode.ON_VISIT_DAY)
        }
    ) {
        SpanText("w dniu wizyty")
    }

    RelativeDayMode.DAYS_OFFSET -> {
        val labelPrefix = when (planType) {
            PlanType.PREPLAN -> "dni przed wizytą"
            PlanType.POSTPLAN -> "dni po wizycie"
        }

        ModeOption(
            onClick = {
                onModeChange(RelativeDayMode.DAYS_OFFSET)
            }
        ) {
            Row(
                horizontalArrangement = Arrangement.spacedBy(12.px),
                verticalAlignment = Alignment.CenterVertically
            ) {
                PlanCreatorIntegerInput(
                    value = daysOffset.coerceAtLeast(1),
                    onValueChange = onDaysOffsetChange,
                    mode = inputMode,
                    textStyle = TextStyles.medium16,
                    minValue = 1
                )
                SpanText(labelPrefix)
            }
        }
    }
    RelativeDayMode.NONE -> ModeOption()
}

@Composable
internal fun RelativeDaySection(
    selectedValue: RelativeDayMode,
    relativeDay: Int,
    planType: PlanType,
    onRelativeDayChange: (Int) -> Unit,
    onModeChange: (RelativeDayMode) -> Unit = {},
    mode: PlanCreatorInputMode,
    enabled: Boolean = true,
) = EditViewSection(
    enabled = enabled,
    title = "Kiedy wykonać?",
    withTitle = false,
) {
    val options = when (planType) {
        PlanType.PREPLAN -> listOf(RelativeDayMode.DAYS_OFFSET, RelativeDayMode.ON_VISIT_DAY)
        PlanType.POSTPLAN -> listOf(RelativeDayMode.ON_VISIT_DAY, RelativeDayMode.DAYS_OFFSET)
    }

    ModeSelectorInput(
        options = options,
        optionToMode = { relativeDayMode ->
            relativeDayModeOption(
                mode = relativeDayMode,
                planType = planType,
                daysOffset = relativeDay,
                inputMode = mode,
                onDaysOffsetChange = onRelativeDayChange,
                onModeChange = onModeChange,
            )
        },
        selectedValue = selectedValue,
        mode = mode,
        enabled = enabled,
    )
}
